import appSketchImageDE_en from '@/static/assets/instant_everything/app-sketch-de-en.svg';
import appSketchImageDE_de from '@/static/assets/instant_everything/app-sketch-de.svg';
import appSketchImageEU_en from '@/static/assets/instant_everything/app-sketch-eu-en.svg';
import appSketchImageFR_fr from '@/static/assets/instant_everything/app-sketch-fr.svg';
import appSketchImageGB_en from '@/static/assets/instant_everything/app-sketch-gb.svg';
import appSketchImageNL_nl from '@/static/assets/instant_everything/app-sketch-nl.svg';
import appSketchImageUS_en from '@/static/assets/instant_everything/app-sketch-us.svg';
import type { Region } from '@lemonade-hq/lemonation';

interface AppSketchProps {
  title: string;
  subtitle: string;
  appSketchImage: Record<Region, Record<string, StaticImageData | string>>;
  appSketchContentLeft: string;
  appSketchContentRight: string;
}
export const INSTANT_EVERYTHING_DEFAULTS: AppSketchProps = {
  title: 'Instant Everything',
  subtitle:
    'Maya, our charming artificial intelligence bot, will craft the perfect insurance for you. \n It couldn’t be easier, or faster',
  appSketchImage: {
    US: {
      en: appSketchImageUS_en,
    },
    DE: {
      en: appSketchImageDE_en,
      de: appSketchImageDE_de,
    },
    NL: {
      nl: appSketchImageNL_nl,
      en: appSketchImageEU_en,
    },
    FR: {
      fr: appSketchImageFR_fr,
      en: appSketchImageEU_en,
    },
    GB: {
      en: appSketchImageGB_en,
    },
  },
  appSketchContentLeft: '<b>90 Seconds</b> \n To get insured',
  appSketchContentRight: '<b>3 Minutes</b> \n To get paid',
};
